import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
import { ConfigProvider } from 'antd';
import plPL from 'antd/locale/pl_PL';
import 'dayjs/locale/pl';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <ConfigProvider
        locale={plPL}
        theme={{
          token: {
            colorPrimary: '#ef343a',
          },
        }}
      >
          <App/>
      </ConfigProvider>
    </CookiesProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
